import { useQuery } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

import { Contact } from './useGetCommunityContacts';

export type ApiResponse_Get_CommunityContact = Contact;

export type ApiRequest_Get_CommunityContact = {
  community_id: number;
};

const ENDPOINT = 'contacts/community';
const METHOD = 'GET';

export const QUERY_KEY = (contactId?: number, communityId?: number) => [
  'contacts',
  'community',
  'single',
  contactId,
  communityId,
];

export const useGetCommunityContact = (contactId: number, communityId: number, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: QUERY_KEY(contactId, communityId),
    queryFn: async (): Promise<ApiResponse_Get_CommunityContact> =>
      handleApiCall<ApiResponse_Get_CommunityContact, ApiRequest_Get_CommunityContact>(
        session,
        METHOD,
        `${ENDPOINT}/${contactId}`,
        {
          community_id: communityId,
        }
      ),
    enabled: enabled && !!communityId && !!session && !!contactId,
  });
};